// Quicklook für Anhänge: Bild, PDF und Audio öffnen sich in einem Modal statt in einem neuen Fenster.
import { useSyncExternalStore } from 'react';

export type VorschauArt = 'bild' | 'pdf' | 'audio';
export type VorschauAnhang = { id: number; filename: string; mime: string; size: number };

export function vorschauArt(a: { mime: string; filename: string }): VorschauArt | null {
  const mime = a.mime.toLowerCase();
  const name = a.filename.toLowerCase();
  if (/^image\/(png|jpeg|gif|webp)$/.test(mime) || /\.(png|jpe?g|gif|webp)$/.test(name))
    return 'bild';
  if (mime === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  if (/^audio\//.test(mime) || /\.(mp3|m4a|wav|ogg)$/.test(name)) return 'audio';
  return null;
}

let aktuell: VorschauAnhang | null = null;
const hoerer = new Set<() => void>();
const melden = () => hoerer.forEach((h) => h());

export function oeffneVorschau(a: VorschauAnhang) {
  aktuell = a;
  melden();
}
export function schliesseVorschau() {
  aktuell = null;
  melden();
}
export function useVorschau() {
  return useSyncExternalStore(
    (h) => (hoerer.add(h), () => hoerer.delete(h)),
    () => aktuell,
  );
}
